import { memo } from 'react'
import { Modal, Button } from '@ow/comps'

const Confirm = ({ title, onConfirm, children, loading }) => {
  return (
    <Modal
      trigger={children}
      showCloseButton
      width="400px"
      title="提示"
      // eslint-disable-next-line react/no-unstable-nested-components
      footer={({ close }) => (
        <>
          <Button
            type="secondary"
            opacityType="sm"
            style={{
              marginRight: '10px',
              visibility: loading ? 'hidden' : 'visible',
            }}
            onClick={close}
          >
            取消
          </Button>
          <Button
            type="primary"
            loading={loading}
            onClick={() => onConfirm(close)}
          >
            确定
          </Button>
        </>
      )}
    >
      <div className="flex flex-col gap-4">
        <div className="text-sm">{title}</div>
      </div>
    </Modal>
  )
}

export default memo(Confirm)
